import { omit } from "lodash";

export function deepDelete<D>(data: D, path: string) {
    const pathParts = path.split(/[.[\]]/).filter(p => !!p);
    const pathToDelete = pathParts[pathParts.length - 1];
    try {
        return recursiveSetAndDelete(data, pathParts, pathToDelete);
    }
    catch {
        throw new Error(`Invalid path: "${path}"`);
    }
}

function recursiveSetAndDelete<O>(obj: O, pathParts: string[], pathToOmit: string): O {
    if (!pathParts.length) {
        return obj as any;
    }

    const [ pathPart, ...remainingPathParts ] = pathParts;
    const subObj = (obj as any)[pathPart];
    return pathPart === pathToOmit ? omit(obj as any, pathToOmit) as O : {
        ...obj,
        [pathPart]: recursiveSetAndDelete(subObj, remainingPathParts, pathToOmit),
    };
}